<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="7" :sm="24">
            <a-form-item label="固定资产名称">
              <a-input placeholder="请输入固定资产名称" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24">
            <a-form-item label="所在项目">
              <a-select
                showSearch
                style="max-width: 200px;min-width: 100%"
                placeholder="请选择"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="使用状态">
              <a-select v-model="queryParam.state" placeholder="请选择" default-value="0">
                <a-select-option value="0">损坏</a-select-option>
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="">全部</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button v-action="'purchase:assets-form:add'" @click="$refs.sxAssetAddOrUpdate.init('','add')" icon="plus" type="primary">新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
      <span slot="action" slot-scope="text,record">
        <div>
          <span v-action="'purchase:assets-form:dam'">
            <a-popconfirm
              title="是否进行报损"
              @confirm="dam(record)"
              okText="是"
              cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red"/>
              <a href="javascript:;" style="color: red">报损</a>
              <a-divider type="vertical" />
            </a-popconfirm>
          </span>
          <span v-action="'purchase:assets-form:distract'">
            <a-tooltip title="修改该固定资产在哪个项目下">
              <a @click="$refs.sxAssetAddOrUpdate.init(record.id,'distract')">转移</a>
            </a-tooltip>
            <a-divider type="vertical" />
          </span>
          <span v-action="'purchase:assets-form:show'">
            <a @click="$refs.sxAssetAddOrUpdate.init(record.id,'show')">详情</a>
          </span>
          <span v-action="'purchase:assets-form:edit'">
            <a-divider type="vertical" />
            <a @click="$refs.sxAssetAddOrUpdate.init(record.id,'edit')">修改</a>
            <a-divider type="vertical" />
          </span>
          <span v-action="'purchase:assets-form:del'">
            <a-popconfirm title="是否删除" @confirm="deleteItem(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;" style="color: red">删除</a>
            </a-popconfirm>
          </span>
        </div>
      </span>
    </s-table>
    <sxAsset-add-or-update
      @ok="queryPage"
      ref="sxAssetAddOrUpdate"
    />
  </a-card>
</template>

<script>
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, damObj, delObj } from '@/api/common/SxAsset'
import sxAssetAddOrUpdate from './SxAssetAddOrUpdate'
import { enterEvent } from '@/utils/util'
import { dropProjectList } from '@/api/project/ProjectInfo'

const stateList = [
  {
    label: '损坏',
    status: 'error',
    value: '0'
  },
  {
    label: '正常',
    status: 'success',
    value: '1'
  }
]

export default {
  name: 'SxAssetView',
  mixins: [TableMixin],
  components: {
    sxAssetAddOrUpdate
  },
  data () {
    return {
      description: '对公司固定资产进行维护和调度',
      queryParam: {
        test: '',
        state: '1',
        projectId: undefined
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '固定资产名称',
          dataIndex: 'name'
        },
        {
          title: '规格',
          dataIndex: 'format'
        },
        {
          title: '数量',
          dataIndex: 'number'
        },
        {
          title: '状态',
          dataIndex: 'state',
          customRender: (record) => {
            return (
              <div>
                {
                  stateList.map(item => {
                    if (item.value === record) {
                      return <a-badge status={item.status} text={item.label} />
                    }
                  })
                }
              </div>
            )
          }
        },
        {
          title: '所在项目',
          dataIndex: 'projectIdName'
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' }
        }
      ],
      projectList: []
    }
  },
  methods: {
    show (record) {
      this.$refs.sxAssetAddOrUpdate.init(record.id, 'show')
    },
    edit (record) {
      this.$refs.sxAssetAddOrUpdate.init(record.id, 'edit')
    },
    dam (record) {
      damObj(record.id).then(res => {
        this.$message.info('报损成功')
        this.queryPage()
      })
    },
    distract (record) {
      this.$refs.sxAssetAddOrUpdate.init(record.id, 'distract')
    },
    deleteItem (record) {
      delObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    }
  },
  created () {
    dropProjectList().then(res => {
      this.projectList = res.data
    })
    enterEvent(this.queryPage)
  }
}
</script>

<style scoped>

</style>
